import React from "react";
import {connect} from "dva";
import {component_tool,framework_tool} from '../../tool';
import {reduxTemplateConfig, templateConfig} from './config';

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
let {WizBrowserExport} = component_tool

class Manager extends WizContainer {
  componentName = 'NotesManager';

  constructor(props) {
    super(props);
    this.state={}
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '标题',
        field: 'title',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '作者',
        field: 'fullName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '关联类型',
        field: 'bizType',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '关联内容',
        field: 'bizName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否公开',
        field: 'isPublic',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '更新时间',
        field: 'lastUpdateTime',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]

    if (o['success']) {
      let bizTypeEnum = {20: '学习资料'}
      let isPublicEnum = {0: '否', 1: '是'}

      let data = o['data']
      data && data.forEach(e => {
        e['bizType'] = bizTypeEnum[e['bizType']] || e['bizType']
        e['isPublic'] = isPublicEnum[e['isPublic']] || e['isPublic']
      })
      WizBrowserExport({
        title: '笔记管理',
        sheetName: '笔记管理',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '笔记管理.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _templateConfig = templateConfig(this)
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: this._handleFile
      },
    });

    return (
      <WizReduxTemplate {..._reduxTemplateConfig} />
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { notes } = state;

  const list = modelUtils.getLoadingState(notes, ['list']);

  return {
    list
  }
};

export default connect(mapStateToProps)(Manager);
